/* RESPONSIBLE TEAM: team-automation-foundations */
import Model, { attr } from '@ember-data/model';

export default class ArticleSuggestion extends Model {
  @attr('boolean') declare enabledForUsers: boolean;
  @attr('boolean') declare enabledForLeads: boolean;

  get isNotDirty() {
    return !this.hasDirtyAttributes;
  }
}
